import { NotificationInstance } from 'antd/es/notification/interface';
import { createFastContext } from '../../contexts/createFastContext';
import { THEME_COLOR } from '../../util/varibles/constants';


interface IState {
    theme: THEME_COLOR
    notify?: NotificationInstance
}

const { Provider, useStore: useTheme } = createFastContext<IState>({
    theme: THEME_COLOR.LIGHT,
});

const ThemeProvider = ({ children, ...props }: {
    children: React.ReactNode,
} & Partial<IState>) => {

    return <Provider props={props}>
        {children}
    </Provider>
}


export { ThemeProvider, useTheme };


